import { defaultReducers, defaultInitialState, IDefaultState } from "../../../../../redux/_common";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";


const initialState = {...defaultInitialState};
const reducers = {...defaultReducers};

export const taskTypesStatusesSlice = createSlice({
  name: "taskTypesStatuses",
  initialState,
  reducers,
});

